import { $api } from "../generated/client";

export default function useSizingSignal(shopId: string, productId: string) {
	return $api.useQuery(
		"get",
		"/shops/{shopId}/sizing/products/{productId}/signal",
		{
			params: { path: { shopId, productId } },
			enabled: !!shopId && !!productId,
		},
	);
}
